import * as _ from 'underscore'

export interface ITemplate {
    forms_action: string;
    forms_fluid: string;
    forms_fluidNoSubmit: string;
    general_empty: string;
    general_loading: string;
    general_notFound: string;
    layouts_base_form_wrapper: string;
    layouts_empty_container: string;
    layouts_empty_div: string;
    layouts_fluid_form_wrapper: string;
    layouts_main: string;
    layouts_section: string;
    layouts_sectionContent: string;
    layouts_uiElements_buttonWidget: string;
    layouts_uiElements_default: string;
    layouts_uiElements_group: string;
    layouts_uiElements_innerRow: string;
    layouts_uiElements_label: string;
    layouts_uiElements_labelValidationWidget: string;
    layouts_uiElements_noValidation: string;
    layouts_uiElements_noWidget: string;
    layouts_uiElements_onlyLabel: string;
    layouts_uiElements_onlyWidget: string;
    layouts_uiElements_row: string;
    layouts_uiElements_simpleWidget: string;
    layouts_uiElements_validation: string;
    layouts_uiElements_widget: string;
    list_cell_boolean: string;
    list_cell_color: string;
    list_cell_enum_span: string;
    list_cell_filterInput: string;
    list_cell_filterOperator: string;
    list_cell_htmlSpan: string;
    list_cell_icon: string;
    list_cell_input: string;
    list_cell_span: string;
    list_view: string;
    list_viewHeader: string;
    modal_base: string;
    modal_confirm: string;
    modal_filter: string;
    modal_form: string;
    modal_list: string;
    modal_listConfirm: string;
    modal_message: string;
    modal_showEndpointUrl: string;
    notification_default: string;
    notification_studioNotification: string;
    table_base: string;
    table_body: string;
    table_bodyWithIsSelectableFn: string;
    table_column_command: string;
    table_column_commands: string;
    table_column_emptyHeader: string;
    table_column_header: string;
    table_draggable_base: string;
    table_draggable_body: string;
    table_draggable_bodyWithIsSelectableFn: string;
    table_empty: string;
    table_header: string;
    table_pager: string;
    table_recursive_base: string;
    table_recursive_body: string;
    table_recursive_bodyWithIsSelectableFn: string;
    table_recursive_draggable_base: string;
    table_recursive_draggable_body: string;
    table_recursive_draggable_bodyWithIsSelectableFn: string;
    table_recursive_header: string;
    table_viewHeader: string;
    widgets_autocomplete: string;
    widgets_button: string;
    widgets_checkbox: string;
    widgets_combobox: string;
    widgets_dateTimePicker: string;
    widgets_fileInput: string;
    widgets_folderPicker: string;
    widgets_formTable: string;
    widgets_iconButton: string;
    widgets_imageFileInput: string;
    widgets_input: string;
    widgets_label: string;
    widgets_labelEdit: string;
    widgets_listConfirmModalButton: string;
    widgets_notification: string;
    widgets_numberInput: string;
    widgets_password: string;
    widgets_qrcode: string;
    widgets_radio: string;
    widgets_simpleCombobox: string;
    widgets_textarea: string;
    widgets_tinyMce: string;
};
export var Templates: ITemplate = _.extend({}, {}, {
    forms_action: 'forms_action',
    forms_fluid: 'forms_fluid',
    forms_fluidNoSubmit: 'forms_fluidNoSubmit',
    general_empty: 'general_empty',
    general_loading: 'general_loading',
    general_notFound: 'general_notFound',
    layouts_base_form_wrapper: 'layouts_base_form_wrapper',
    layouts_empty_container: 'layouts_empty_container',
    layouts_empty_div: 'layouts_empty_div',
    layouts_fluid_form_wrapper: 'layouts_fluid_form_wrapper',
    layouts_main: 'layouts_main',
    layouts_section: 'layouts_section',
    layouts_sectionContent: 'layouts_sectionContent',
    layouts_uiElements_buttonWidget: 'layouts_uiElements_buttonWidget',
    layouts_uiElements_default: 'layouts_uiElements_default',
    layouts_uiElements_group: 'layouts_uiElements_group',
    layouts_uiElements_innerRow: 'layouts_uiElements_innerRow',
    layouts_uiElements_label: 'layouts_uiElements_label',
    layouts_uiElements_labelValidationWidget: 'layouts_uiElements_labelValidationWidget',
    layouts_uiElements_noValidation: 'layouts_uiElements_noValidation',
    layouts_uiElements_noWidget: 'layouts_uiElements_noWidget',
    layouts_uiElements_onlyLabel: 'layouts_uiElements_onlyLabel',
    layouts_uiElements_onlyWidget: 'layouts_uiElements_onlyWidget',
    layouts_uiElements_row: 'layouts_uiElements_row',
    layouts_uiElements_simpleWidget: 'layouts_uiElements_simpleWidget',
    layouts_uiElements_validation: 'layouts_uiElements_validation',
    layouts_uiElements_widget: 'layouts_uiElements_widget',
    list_cell_boolean: 'list_cell_boolean',
    list_cell_color: 'list_cell_color',
    list_cell_enum_span: 'list_cell_enum_span',
    list_cell_filterInput: 'list_cell_filterInput',
    list_cell_filterOperator: 'list_cell_filterOperator',
    list_cell_htmlSpan: 'list_cell_htmlSpan',
    list_cell_icon: 'list_cell_icon',
    list_cell_input: 'list_cell_input',
    list_cell_span: 'list_cell_span',
    list_view: 'list_view',
    list_viewHeader: 'list_viewHeader',
    modal_base: 'modal_base',
    modal_confirm: 'modal_confirm',
    modal_filter: 'modal_filter',
    modal_form: 'modal_form',
    modal_list: 'modal_list',
    modal_listConfirm: 'modal_listConfirm',
    modal_message: 'modal_message',
    modal_showEndpointUrl: 'modal_showEndpointUrl',
    notification_default: 'notification_default',
    notification_studioNotification: 'notification_studioNotification',
    table_base: 'table_base',
    table_body: 'table_body',
    table_bodyWithIsSelectableFn: 'table_bodyWithIsSelectableFn',
    table_column_command: 'table_column_command',
    table_column_commands: 'table_column_commands',
    table_column_emptyHeader: 'table_column_emptyHeader',
    table_column_header: 'table_column_header',
    table_draggable_base: 'table_draggable_base',
    table_draggable_body: 'table_draggable_body',
    table_draggable_bodyWithIsSelectableFn: 'table_draggable_bodyWithIsSelectableFn',
    table_empty: 'table_empty',
    table_header: 'table_header',
    table_pager: 'table_pager',
    table_recursive_base: 'table_recursive_base',
    table_recursive_body: 'table_recursive_body',
    table_recursive_bodyWithIsSelectableFn: 'table_recursive_bodyWithIsSelectableFn',
    table_recursive_draggable_base: 'table_recursive_draggable_base',
    table_recursive_draggable_body: 'table_recursive_draggable_body',
    table_recursive_draggable_bodyWithIsSelectableFn: 'table_recursive_draggable_bodyWithIsSelectableFn',
    table_recursive_header: 'table_recursive_header',
    table_viewHeader: 'table_viewHeader',
    widgets_autocomplete: 'widgets_autocomplete',
    widgets_button: 'widgets_button',
    widgets_checkbox: 'widgets_checkbox',
    widgets_combobox: 'widgets_combobox',
    widgets_dateTimePicker: 'widgets_dateTimePicker',
    widgets_fileInput: 'widgets_fileInput',
    widgets_folderPicker: 'widgets_folderPicker',
    widgets_formTable: 'widgets_formTable',
    widgets_iconButton: 'widgets_iconButton',
    widgets_imageFileInput: 'widgets_imageFileInput',
    widgets_input: 'widgets_input',
    widgets_label: 'widgets_label',
    widgets_labelEdit: 'widgets_labelEdit',
    widgets_listConfirmModalButton: 'widgets_listConfirmModalButton',
    widgets_notification: 'widgets_notification',
    widgets_numberInput: 'widgets_numberInput',
    widgets_password: 'widgets_password',
    widgets_qrcode: 'widgets_qrcode',
    widgets_radio: 'widgets_radio',
    widgets_simpleCombobox: 'widgets_simpleCombobox',
    widgets_textarea: 'widgets_textarea',
    widgets_tinyMce: 'widgets_tinyMce'
});
export var Template = _.extend({}, {}, {
    [Templates.forms_action]: `<a class="action" data-bind="click: command, css: css, visible: visible"><span data-bind="text: label"></span></a>`,
    [Templates.forms_fluid]: `<div class="fluid-items content mapp-row" data-bind="foreach: uiElements">
    <!-- ko template: { name: template, data: $data, as: 'uiElement' } -->
    <!-- /ko -->
</div>
<div class="clear"></div>
<div class="action-bar action-theme-blue-bar align-right" data-bind="foreach: commands">
    <!-- ko template: { name: template, data: $data } -->
    <!-- /ko -->
</div>`,
    [Templates.forms_fluidNoSubmit]: `<div class="fluid-items content mapp-row" data-bind="foreach: uiElements">
    <!-- ko template: { name: template, data: $data, as: 'uiElement' } -->
    <!-- /ko -->
</div>`,
    [Templates.general_empty]: ``,
    [Templates.general_loading]: `<div id="loadingdot-wrapper" style="display:none">
    <div id="loadingdot">
        <div id="loadingdot_1" class="loadingdot"></div>
        <div id="loadingdot_2" class="loadingdot"></div>
        <div id="loadingdot_3" class="loadingdot"></div>
        <div id="loadingdot_4" class="loadingdot"></div>
        <div id="loadingdot_5" class="loadingdot"></div>
        <div id="loadingdot_6" class="loadingdot"></div>
        <div id="loadingdot_7" class="loadingdot"></div>
        <div id="loadingdot_8" class="loadingdot"></div>
    </div>
</div>`,
    [Templates.general_notFound]: `<span data-bind="text: mapp.Localization.Errors.NotFound"></span>`,
    [Templates.layouts_base_form_wrapper]: `<div class="form-wrapper base-form-theme">
    <!-- ko template: { name: form.template, data: form } -->
    <!-- /ko -->
</div>`,
    [Templates.layouts_empty_container]: `<div class="form-wrapper base-form-theme flex-container">
    <div data-bind="element: element"></div>
</div>`,
    [Templates.layouts_empty_div]: `<div data-bind="element: element"></div>
`,
    [Templates.layouts_fluid_form_wrapper]: `<div class="form-wrapper base-form-theme">
    <!-- ko template: { name: form.template, data: form } -->
    <!-- /ko -->
</div>`,
    [Templates.layouts_main]: `<main class="mapp-studio-main">
    <header class="mapp-header" data-bind="template: { name: header.template, data: header }"></header>
    <header class="mapp-navigation" data-bind="template: { name: navigation.template, data: navigation }"></header>
    <section class="mapp-content no-gutter mapp-cell-1-1" data-bind="with: activeView">
        <div class="mapp-loading-area">
            <!-- ko template: mapp.Templates.general_loading -->
            <!-- /ko -->
            <!-- ko template: { name: template, data: $data } -->
            <!-- /ko -->
        </div>
    </section>
    <!-- ko with: mapp.ModalUtil.activeModal -->
    <!-- ko template: { name: template }-->
    <!-- /ko -->
    <!-- /ko -->
    <section class="mapp-modal-container">
    </section>
    <section class="mapp-settings" data-bind="css: header.settingsCss">
        <section class="mapp-user" data-bind="template: { name: user.template, data: user }"></section>
        <div class="settings-form-wrapper"
            data-bind="template: { name: mapp.Templates.layouts_fluid_form_wrapper, data: header }"></div>
    </section>
</main>`,
    [Templates.layouts_section]: `<!--ko with: activeView -->
<div class="view" data-bind="template: { name: template, data: $data }, attr: { id: elementId }, css: { 'full-height': isFullHeight }"></div>
<!-- /ko-->`,
    [Templates.layouts_sectionContent]: `<!--ko with: activeView -->
<div class="section-content" data-bind="template: { name: template, data: $data }, attr: { id: elementId }"></div>
<!-- /ko-->`,
    [Templates.layouts_uiElements_buttonWidget]: `<!-- ko if: hasLOffset -->
<div class="mapp-offset" data-bind="css: lOffset"></div>
<!-- /ko -->
<div class="widget-wrapper" data-bind="visible: visible, css:css">
    <div class="ui-action-wrapper" data-bind="template: { name: widget.widget, data: $data }, css: widget.css, validationElement: value">
    </div>
</div>
<!-- ko if: hasROffset -->
<div class="mapp-offset" data-bind="css: rOffset"></div>
<!-- /ko -->`,
    [Templates.layouts_uiElements_default]: `<!-- ko if: hasLOffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: lOffset"></div>
<!-- /ko -->
<div class="widget-wrapper" data-bind="visible: visible, css: css">
    <!-- ko template: { name: label.template, data: label } -->
    <!-- /ko -->
    <!-- ko template: { name: validation.template, data: validation } -->
    <!-- /ko -->
    <!-- ko template: { name: widget.template, data: widget } -->
    <!-- /ko -->
</div>
<!-- ko if: hasROffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: rOffset"></div>
<!-- /ko -->`,
    [Templates.layouts_uiElements_group]: `<div data-bind="foreach: uiElements, visible: visible, css: css">
<!-- ko template: { name: template, data: $data, as: 'uiElement' } -->
<!-- /ko -->
</div>`,
    [Templates.layouts_uiElements_innerRow]: `<div class="mapp-inner-row" data-bind="visible: visible, css: css">
    <div class="mapp-inner-row-wrapper mapp-cell-1-1" data-bind="foreach: uiElements">
        <!-- ko template: { name: template, data: $data, as: 'uiElement' } -->
        <!-- /ko -->
    </div>
</div>`,
    [Templates.layouts_uiElements_label]: `<label class="" data-bind="text: label, attr: { for: base.id }, css: css"></label>`,
    [Templates.layouts_uiElements_labelValidationWidget]: `<!-- ko if: hasLOffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: lOffset"></div>
<!-- /ko -->
<div class="widget-wrapper" data-bind="visible: visible, css: css">
    <!-- ko template: { name: label.template, data: label } -->
    <!-- /ko -->
    <!-- ko template: { name: validation.template, data: validation } -->
    <!-- /ko -->
    <!-- ko template: { name: widget.template, data: widget } -->
    <!-- /ko -->
</div>
<!-- ko if: hasROffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: rOffset"></div>
<!-- /ko -->`,
    [Templates.layouts_uiElements_noValidation]: `<!-- ko if: hasLOffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: lOffset"></div>
<!-- /ko -->
<div class="widget-wrapper" data-bind="visible: visible, css: css">
    <!-- ko template: { name: label.template, data: label } -->
    <!-- /ko -->
    <!-- ko template: { name: widget.template, data: widget } -->
    <!-- /ko -->
</div>
<!-- ko if: hasROffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: rOffset"></div>
<!-- /ko -->`,
    [Templates.layouts_uiElements_noWidget]: `<!-- ko if: hasLOffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: lOffset"></div>
<!-- /ko -->
<div class="widget-wrapper" data-bind="visible: visible, css: css">
    <!-- ko template: { name: label.template, data: label } -->
    <!-- /ko -->
    <!-- ko template: { name: validation.template, data: validation } -->
    <!-- /ko -->
</div>
<!-- ko if: hasROffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: rOffset"></div>
<!-- /ko -->`,
    [Templates.layouts_uiElements_onlyLabel]: `<!-- ko if: hasLOffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: lOffset"></div>
<!-- /ko -->
<div class="widget-wrapper" data-bind="visible: visible, css: css">
    <!-- ko template: { name: label.template, data: label } -->
    <!-- /ko -->
</div>
<!-- ko if: hasROffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: rOffset"></div>
<!-- /ko -->`,
    [Templates.layouts_uiElements_onlyWidget]: `<!-- ko if: hasLOffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: lOffset"></div>
<!-- /ko -->
<div class="widget-wrapper" data-bind="visible: visible, css: css">
    <!-- ko template: { name: widget.template, data: widget } -->
    <!-- /ko -->
</div>
<!-- ko if: hasROffset -->
<div class="widget-wrapper mapp-offset" data-bind="css: rOffset"></div>
<!-- /ko -->`,
    [Templates.layouts_uiElements_row]: `<div class="mapp-row" data-bind="foreach: uiElements, visible: visible, css: css">
<!-- ko template: { name: template, data: $data, as: 'uiElement' } -->
<!-- /ko -->
</div>`,
    [Templates.layouts_uiElements_simpleWidget]: `<div data-bind="template: { name: widget, data: $data }, css: css">
</div>`,
    [Templates.layouts_uiElements_validation]: `<div data-bind="css: css">
    <span data-bind="validationMessage: base.value"></span>
</div>`,
    [Templates.layouts_uiElements_widget]: `<div data-bind="template: { name: widget, data: $data }, css: css, validationElement: value">
</div>`,
    [Templates.list_cell_boolean]: `<div class="cell-boolean no-cursor" data-bind="css: { 'hehe-icons-check' : item[property.key] }"></div>`,
    [Templates.list_cell_color]: `<input type="color" data-bind="value: mapp.Util.getProperty(item, property.key)">`,
    [Templates.list_cell_enum_span]: `<span data-bind="text: mapp.Util.getEnumProperty(item, property.key, property.enumType)"></span>`,
    [Templates.list_cell_filterInput]: `<div class="widget-wrapper cell-widget">
    <input data-bind="textInput: item.value" />
</div>`,
    [Templates.list_cell_filterOperator]: `<div class="widget-wrapper cell-widget">
    <select data-bind="value: item.operator, options: item.operatorData, optionsText: 'label', optionsValue: 'id', optionsCaption: mapp.Localization.Progress.ChooseFilter"></select>
</div>`,
    [Templates.list_cell_htmlSpan]: `<span data-bind="html: mapp.Util.getProperty(item, property.key)"></span>`,
    [Templates.list_cell_icon]: `<a class="row-icon" data-bind="css: mapp.Util.getProperty(item, property.key)"></a>`,
    [Templates.list_cell_input]: `<div class="widget-wrapper list-cell">
    <div data-bind="validationElement: mapp.Util.getProperty(item, property.key)">
        <div data-bind="visible: mapp.Util.getProperty(item, property.key.concat(mapp.ID.HasFocus))">
            <span class="validation" data-bind="validationMessage: mapp.Util.getProperty(item, property.key)"></span>
        </div>
        <input data-bind="value: mapp.Util.getProperty(item, property.key), hasFocus: mapp.Util.getProperty(item, property.key.concat(mapp.ID.HasFocus))" />
    </div>
</div>`,
    [Templates.list_cell_span]: `<span data-bind="text: mapp.Util.getProperty(item, property.key)"></span>`,
    [Templates.list_view]: `<!-- ko template: { name: mapp.Templates.list_viewHeader, data: table }-->
<!-- /ko -->
<!-- ko template: { name: mapp.Templates.table_base, data: table }-->
<!-- /ko -->`,
    [Templates.list_viewHeader]: `<div class="section-table-header">
    <div data-bind="click: isDeleteActive ? clickDeleteSelected : null, css: {'active': isDeleteActive}, visible: isDeleteVisible">
        <a class="icon hehe-icons-delete">
            <span data-bind="text: mapp.Localization.Delete"></span>&nbsp;<span class="selected-count" data-bind="text: selectionDeleteCountLabel"></span>
        </a>
    </div>
    <div data-bind="click: clickNew, css: {'active': isNewActive}, visible: isNewVisible">
        <a class="icon hehe-icons-form">
            <span  data-bind="text: mapp.Localization.New"></span>
        </a>
    </div>
    <div data-bind="click: clickSave, css: {'active': isSaveActive}, visible: isSaveVisible">
        <a class="icon hehe-icons-save">
            <span data-bind="text: mapp.Localization.Save"></span>&nbsp;<span class="selected-count" data-bind="text: editingCountLabel"></span>
        </a>
    </div>
    <div data-bind="click: clickCancel, css: {'active': isSaveActive}, visible: isSaveVisible">
        <a class="icon hehe-icons-cancel">
            <span data-bind="text: mapp.Localization.Cancel"></span>&nbsp;<span class="selected-count" data-bind="text: editingCountLabel"></span>
        </a>
    </div>
    <div data-bind="click: clickFilter, css: {'active': isFilterActive}, visible: isFilterVisible">
        <a class="icon mapp-studio-icons-filter">
            <span data-bind="text: mapp.Localization.Filter"></span>&nbsp;<span class="selected-count" data-bind="text: filterCountLabel"></span>
        </a>
    </div>
    <div class="widget" data-bind="css: {'active': isSearchActive}, visible: isSearchVisible">
        <input class="list-header-input" type="text" data-bind="attr: {placeholder: mapp.Localization.Search}, textInput: searchInput" />
    </div>
    <div data-bind="click: clickInvalid, css: {'active': isInvalidActive}, visible: isInvalidVisible">
        <a class="icon mapp-studio-icons-ban color-red">
            <span data-bind="text: mapp.Localization.Invalid"></span>&nbsp;<span class="selected-count" data-bind="text: invalidCountLabel"></span>
        </a>
    </div>
    <!-- ko foreach: customTableActions -->
    <div data-bind="click: onClick, css: {'active': isActive}">
        <a data-bind="css: icon">
            <span data-bind="text: label"></span>
        </a>
    </div>
    <!-- /ko -->
</div>`,
    [Templates.modal_base]: `<div class="modal" data-bind="attr: { id: id }, style: { height: height, width: width, 'min-width': minWidth }, css: { 'on': visible }">
    <div class="header">
        <span data-bind="text: title">
        </span>
        <a data-bind="click: clickClose">
            x
        </a>
    </div>
    <div class="modal-content" data-bind="template: { name: contentTemplate, data: $data }"></div>
</div>`,
    [Templates.modal_confirm]: `<div class="modal-wrapper">
    <div class="content mapp-row">
        <div class="bold" data-bind="visible: displayHeadline, css: {'mapp-cell-1-1': displayHeadline}">
            <span data-bind="html: headLine"></span>
        </div>
        <div class="mapp-cell-1-1" data-bind="css: { 'margin-top-medium': displayHeadline}">
            <span data-bind="html: message"></span>
        </div>
    </div>
    <div class="clear"></div>
    <div class="action-bar action-theme-blue-bar align-right margin-top-medium">
        <a class="action" data-bind="click: clickClose, text: closeLabel"></a>
        <a class="action" data-bind="click: clickConfirm, text: confirmLabel"></a>
    </div>
</div>`,
    [Templates.modal_filter]: `<div class="filter-modal-wrapper base-form-theme">
    <div class="content mapp-row">
        <div class="fluid-items mapp-cell-1-1">
            <!-- ko template: { name: columns.template, data: columns } -->
            <!-- /ko -->
            <!-- ko template: { name: addFilterButton.template, data: addFilterButton } -->
            <!-- /ko -->
            <div class="clear"></div>
        </div>
        <div class="mapp-cell-1-1">
            <!-- ko template: { name: mapp.Templates.table_base, data: filterTable } -->
            <!-- /ko -->
        </div>
    </div>
    <div class="clear"></div>
    <div class="action-bar action-theme-blue-bar align-right margin-top-medium">
        <a class="action" data-bind="click: clickClear, text: closeLabel"></a>
        <a class="action" data-bind="click: clickClose, text: applyLabel"></a>
    </div>
</div>`,
    [Templates.modal_form]: `<div class="modal-wrapper">
    <div class="base-form-theme">
        <!-- ko template: { name: form.template, data: form } -->
        <!-- /ko -->
    </div>
    <div class="clear"></div>
    <div class="action-bar action-theme-blue-bar align-right margin-top-medium">
        <a class="action" data-bind="click: clickClose, text: closeLabel"></a>
        <a class="action" data-bind="click: clickOk, text: okLabel"></a>
    </div>
</div>`,
    [Templates.modal_list]: `<div class="modallist-wrapper">
    <div class="content mapp-row">
        <div class="mapp-cell-1-1">
            <!-- ko template: { name: mapp.Templates.table_viewHeader, data: table } -->
            <!-- /ko -->
            <!-- ko template: { name: mapp.Templates.table_base, data: table } -->
            <!-- /ko -->
        </div>
    </div>
    <div class="clear"></div>
    <div class="action-bar action-theme-blue-bar align-right margin-top-medium">
        <a class="action" data-bind="click: clickClose, text: confirmLabel"></a>
    </div>
</div>`,
    [Templates.modal_listConfirm]: `<div class="modallist-wrapper">
    <div class="content mapp-row">
        <div class="mapp-cell-1-1" style="height: 520px">
            <!-- ko template: { name: mapp.Templates.table_viewHeader, data: table } -->
            <!-- /ko -->
            <!-- ko template: { name: mapp.Templates.table_base, data: table } -->
            <!-- /ko -->
        </div>
    </div>
    <div class="clear"></div>
    <div class="action-bar action-theme-blue-bar align-right margin-top-medium">
        <a class="action" data-bind="click: clickClose, text: closeLabel"></a>
        <a class="action" data-bind="click: clickConfirm, text: confirmLabel"></a>
    </div>
</div>`,
    [Templates.modal_message]: `<div class="modal-wrapper">
    <div class="content mapp-row">
        <div class="mapp-cell-1-1">
            <span data-bind="text: message"></span>
        </div>
    </div>
    <div class="clear"></div>
    <div class="action-bar action-theme-blue-bar align-right margin-top-medium">
        <a class="action" data-bind="click: clickClose, text: closeLabel"></a>
    </div>
</div>`,
    [Templates.modal_showEndpointUrl]: `<div class="modal-wrapper endpoint-url-modal-wrapper">
    <table class="endpoint-url-table" style="width: 100%">
        <tr data-bind="if: WMS">
            <td>WMS</td>
            <td><input readonly class="mapp-cell-1-1" data-bind="value: WMS, attr: { 'id': itemId() + '_WMS' }"/></td>
            <td><button type="button" data-bind="click: copyToClickBoard('_WMS', event), attr: { title: tooltip, 'disabled' : WMSpublished }"  class="mapp-studio-icons-clipboard"></button></td>
        </tr>
        <tr data-bind="if: WMTS">
            <td>WMTS</td>
            <td>
                <input readonly class="mapp-cell-1-1" data-bind="value: WMTS, attr: { 'id': itemId() + '_WMTS' }"/>
            </td>
            <td><button type="button" data-bind="click: copyToClickBoard('_WMTS', event), attr: { title: tooltip, 'disabled' : WMTSpublished }" class="mapp-studio-icons-clipboard"></button></td>
        </tr>
        <tr data-bind="if: WFS">
            <td>WFS</td>
            <td>
                <input readonly class="mapp-cell-1-1" data-bind="value: WFS, attr: { 'id': itemId() + '_WFS' }"/>
            </td>
            <td><button type="button" data-bind="click: copyToClickBoard('_WFS', event), attr: { title: tooltip, 'disabled' : WFSpublished }" class="mapp-studio-icons-clipboard"></button></td>
        </tr>
    </table>
</div>
<div class="endpoint-url-copied-notification" data-bind="css: { 'extended': extended }" >
    <span data-bind="text: notification"></span>
</div>`,
    [Templates.notification_default]: `<div class="notification" data-bind="css: type, visible: visible">
    <span class="text" data-bind="text: text"></span>
    <a class="icon" data-bind="click: clickHide"></a>
</div>`,
    [Templates.notification_studioNotification]: `<div class="icon"></div>
<div class="message">
    <div class="title" data-bind="text: title, attr: {title: title}"></div>
    <div class="text" data-bind="text: text, attr: {title: title}"></div>
</div>
<a class="close action hide-action hehe-icons-cancel" data-bind="click: close"></a>`,
    [Templates.table_base]: `<div class="table-wrapper no-gutter mapp-cell-1-1">
    <table class="base-table">
        <thead data-bind="template: { name: mapp.Templates.table_header, data: $data }"></thead>
        <!-- ko ifnot: hasIsSelectableFn -->
        <tbody data-bind="template: { name: mapp.Templates.table_body, foreach: view, as: 'item' }"></tbody>
        <!-- /ko -->
        <!-- ko if: hasIsSelectableFn -->
        <tbody data-bind="template: { name: mapp.Templates.table_bodyWithIsSelectableFn, foreach: view, as: 'item' }"></tbody>
        <!-- /ko -->
    </table>
    <!-- ko template: { name: mapp.Templates.table_empty, data: $data }-->
    <!-- /ko -->
    <!-- ko template: { name: mapp.Templates.table_pager, data: $data }-->
    <!-- /ko -->
</div>`,
    [Templates.table_body]: `<tr data-bind="css: { 'inline-editing': $parent.isEditing(item) }">
    <!-- ko if: $parent.isSelectionOn -->
    <td>
        <div class="checkbox" data-bind="css: { 'hehe-icons-check' : $parent.isSelected(item) }, click: $parent.toggleSelection"></div>
    </td>
    <!-- /ko -->
    <!-- ko foreach: { data: $parent.properties, as: 'property' } -->
        <!-- ko if: property.isEditable -->
            <!-- ko if: $parents[1].isEditing(item) -->
                <td data-bind="template: { name: property.editTemplate, data: $parents[1].getEditObject(item), as: 'item' }, css: property.cellCss, event: {keyup: $parents[1].keyPress}"></td>
            <!-- /ko -->
            <!-- ko ifnot: $parents[1].isEditing(item) -->
                <td data-bind="template: property.template, css: property.cellCss, customClick: { double: $parents[1].toggleEditing.bind($parents[1], item) }"></td>
            <!-- /ko -->
        <!-- /ko -->
        <!-- ko ifnot: property.isEditable -->
        <td data-bind="template: property.template, css: property.cellCss, click: property.click.bind(item)"></td>
        <!-- /ko -->
    <!-- /ko -->
</tr>`,
    [Templates.table_bodyWithIsSelectableFn]: `<tr data-bind="css: { 'inline-editing': $parent.isEditing(item) }">
    <!-- ko if: $parent.isSelectionOn -->
    <td>
        <!-- ko if: $parent.isSelectable(item) -->
        <div class="checkbox" data-bind="css: { 'hehe-icons-check' : $parent.isSelected(item) }, click: $parent.toggleSelection"></div>
        <!-- /ko -->
    </td>
    <!-- /ko -->
    <!-- ko foreach: { data: $parent.properties, as: 'property' } -->
        <!-- ko if: property.isEditable -->
            <!-- ko if: $parents[1].isEditing(item) -->
                <td data-bind="template: { name: property.editTemplate, data: $parents[1].getEditObject(item), as: 'item' }, css: property.cellCss, event: {keyup: $parents[1].keyPress}"></td>
            <!-- /ko -->
            <!-- ko ifnot: $parents[1].isEditing(item) -->
                <td data-bind="template: property.template, css: property.cellCss, customClick: { double: $parents[1].toggleEditing.bind($parents[1], item) }"></td>
            <!-- /ko -->
        <!-- /ko -->
        <!-- ko ifnot: property.isEditable -->
        <td data-bind="template: property.template, css: property.cellCss, click: property.click.bind(item)"></td>
        <!-- /ko -->
    <!-- /ko -->
</tr>`,
    [Templates.table_column_command]: `<a data-bind="click: command.bind($data, $parents[2], $parents[3]), css: cssFn($parents[2]), attr: { title: labelFn($parents[2]) }, visible: visible($parents[2]), editable: editable($parents[2])" class="row-action">
</a>`,
    [Templates.table_column_commands]: `<!-- ko foreach: { data: property.commands, as: 'commandObj' }-->
<!-- ko template: { name: commandObj.template, data: commandObj } -->
<!-- /ko -->
<!-- /ko -->`,
    [Templates.table_column_emptyHeader]: `<th data-bind="click: $parent.clickOnProperty, css: css">
    <span class="sortstate" data-bind="css: sortStateCss"></span>
</th>`,
    [Templates.table_column_header]: `<th data-bind="click: $parent.clickOnProperty, css: css">
    <!-- ko if: headerAlign == mapp.Align.RIGHT -->
    <span class="sortstate" data-bind="css: sortStateCss"></span>
    <!-- /ko -->
    <span data-bind="text: label"></span>
    <!-- ko ifnot: headerAlign == mapp.Align.RIGHT -->
    <span class="sortstate" data-bind="css: sortStateCss"></span>
    <!-- /ko -->
</th>`,
    [Templates.table_draggable_base]: `<div class="table-wrapper no-gutter mapp-cell-1-1">
    <table class="base-table">
        <thead data-bind="template: { name: mapp.Templates.table_header, data: $data }"></thead>
        <!-- ko ifnot: hasIsSelectableFn -->
        <tbody data-bind="template: { name: mapp.Templates.table_draggable_body, foreach: view, as: 'item' }"></tbody>
        <!-- /ko -->
        <!-- ko if: hasIsSelectableFn -->
        <tbody data-bind="template: { name: mapp.Templates.table_draggable_bodyWithIsSelectableFn, foreach: view, as: 'item' }"></tbody>
        <!-- /ko -->
    </table>
    <!-- ko template: { name: mapp.Templates.table_empty, data: $data }-->
    <!-- /ko -->
    <!-- ko template: { name: mapp.Templates.table_pager, data: $data }-->
    <!-- /ko -->
</div>`,
    [Templates.table_draggable_body]: `<tr data-bind="draggable: { data: $data, as: 'item', options: { helper: 'clone' }}">
    <!-- ko if: $parent.isSelectionOn -->
    <td>
        <div class="checkbox" data-bind="css: { 'hehe-icons-check' : $parent.isSelected(item) }, click: $parent.toggleSelection"></div>
    </td>
    <!-- /ko -->
    <!-- ko foreach: { data: $parent.properties, as: 'property' } -->
    <td data-bind="template: property.template, css: property.cellCss "></td>
    <!-- /ko -->
</tr>`,
    [Templates.table_draggable_bodyWithIsSelectableFn]: `<tr data-bind="draggable: { data: $data, isEnabled: $parent.isSelectable(item), options: { helper: 'clone' }}">
    <!-- ko if: $parents[1].isSelectionOn -->
    <td>
        <!-- ko if: $parents[1].isSelectable(item) -->
        <div class="checkbox" data-bind="css: { 'hehe-icons-check' : $parents[1].isSelected(item) }, click: $parents[1].toggleSelection"></div>
        <!-- /ko -->
    </td>
    <!-- /ko -->
    <!-- ko foreach: { data: $parents[1].properties, as: 'property' } -->
    <td data-bind="template: property.template, css: property.cellCss "></td>
    <!-- /ko -->
</tr>
`,
    [Templates.table_empty]: `<div class="table-empty" data-bind="visible: isEmpty">
    <span data-bind="text: mapp.Localization.NoItems"></span>
</div>
<div class="table-empty border-bottom" data-bind="visible: viewIsEmpty">
    <span data-bind="text: mapp.Localization.NoItemFilter"></span>
</div>`,
    [Templates.table_header]: `<tr>
    <!-- ko if: isSelectionOn -->
    <th class="checkbox-column">
        <!-- ko if: isMultipleSelectionOn -->
        <div class="checkbox" data-bind="css: selectionCss, click: toggleAllSelection"></div>
        <!-- /ko -->
    </th>
    <!-- /ko -->
    <!-- ko foreach: properties -->
    <!-- ko template: { name: headerTemplate }-->
    <!-- /ko -->
    <!-- /ko -->
</tr>`,
    [Templates.table_pager]: `<!-- ko if: isPagingOn -->
<!-- ko ifnot: isEmpty -->
<div class="base-table-pager">
    <a class="mapp-studio-icons-angle-double-left" data-bind="click: clickFirstPage, css: { 'disabled': !isPreviousPageable() }"></a>
    <a class="mapp-studio-icons-angle-left" data-bind="click: clickPreviousPage, css: { 'disabled': !isPreviousPageable() }"></a>
    <!-- ko ifnot: pageSetterVisible -->
    <span class="page-selector">
        <!-- ko foreach: new Array(pageCount()) -->
        <a class="page" data-bind="text: $index()+1, click: $parent.clickPage.bind($parent, $index()+1), css: { 'selected': $index()+1 == $parent.currentPage() }"></a>
        <!-- /ko -->
    </span>
    <!-- /ko -->
    <!-- ko if: pageSetterVisible -->
    <span class="page-setter">
        <input class="page-index" type="number" data-bind="textInput: pagingIndexKeyUp, attr: {max: pageCount()}, event: {keyup: setPage}, hasFocus: pagerInputFocus" pattern="[0-9]*" />
        &nbsp;of&nbsp;&nbsp;<span data-bind="text: pageCount()"></span>
    </span>
    <!-- /ko -->
    <a class="mapp-studio-icons-angle-right" data-bind="click: clickNextPage, css: { 'disabled': !isNextPageable() }"></a>
    <a class="mapp-studio-icons-angle-double-right" data-bind="click: clickLastPage, css: { 'disabled': !isNextPageable() }"></a>
    <span class="items-count" data-bind="text: itemsCountInfo"></span>
</div>
<!-- /ko -->
<!-- /ko -->`,
    [Templates.table_recursive_base]: `<!-- ko foreach: { data: $data, as: 'list' } -->
<div class="recursive-table-wrapper table-wrapper box-shadow no-gutter mapp-cell-1-1">
    <table class="base-table">
        <thead data-bind="template: { name: mapp.Templates.table_recursive_header, data: $data }"></thead>
        <!-- ko ifnot: list.hasIsSelectableFn-->
        <tbody data-bind="template: { name: mapp.Templates.table_recursive_body, foreach: list.view, as: 'item' }"></tbody>
        <!-- /ko -->
        <!-- ko if: list.hasIsSelectableFn-->
        <tbody data-bind="template: { name: mapp.Templates.table_recursive_bodyWithIsSelectableFn, foreach: list.view, as: 'item' }"></tbody>
        <!-- /ko -->
    </table>
</div>
<!-- /ko -->`,
    [Templates.table_recursive_body]: `
<tr>
    <!-- ko if: list.isSelectionOn -->
    <td>
        <div class="checkbox" data-bind="css: list.recursiveSelectionStateCss(item), click: list.toggleSelection"></div>
    </td>
    <!-- /ko -->
    <!-- ko foreach: { data: list.properties, as: 'property' } -->
    <td data-bind="template: property.template, css: property.cellCss, click: property.click.bind(item) "></td>
    <!-- /ko -->
</tr>
<!-- ko foreach: list.dataSource.getFlatChildrenData(item) -->
    <!-- ko foreach: { data: view, as: 'item' } -->
        <!-- ko template: list.getItemTemplate(item) -->
        <!-- /ko-->
    <!-- /ko-->
<!-- /ko-->`,
    [Templates.table_recursive_bodyWithIsSelectableFn]: `<tr>
    <!-- ko if: list.isSelectionOn -->
    <td>
        <!-- ko if: list.isSelectable(item) -->
        <div class="checkbox" data-bind="css: list.recursiveSelectionStateCss(item), click: list.toggleSelection"></div>
        <!-- /ko -->
    </td>
    <!-- /ko -->
    <!-- ko foreach: { data: list.properties, as: 'property' } -->
    <td data-bind="template: property.template, css: property.cellCss, click: property.click.bind(item) "></td>
    <!-- /ko -->
</tr>
<!-- ko foreach: list.dataSource.getFlatChildrenData(item) -->
    <!-- ko foreach: { data: view, as: 'item' } -->
        <!-- ko template: list.getItemTemplate(item) -->
        <!-- /ko-->
    <!-- /ko-->
<!-- /ko-->`,
    [Templates.table_recursive_draggable_base]: `<!-- ko foreach: { data: $data, as: 'list' } -->
<div class="recursive-table-wrapper table-wrapper box-shadow no-gutter mapp-cell-1-1">
    <table class="base-table">
        <thead data-bind="template: { name: mapp.Templates.table_recursive_header, data: $data }"></thead>
        <!-- ko ifnot: list.hasIsSelectableFn-->
        <tbody data-bind="template: { name: mapp.Templates.table_recursive_draggable_body, foreach: list.view, as: 'item' }"></tbody>
        <!-- /ko -->
        <!-- ko if: list.hasIsSelectableFn-->
        <tbody data-bind="template: { name: mapp.Templates.table_recursive_draggable_bodyWithIsSelectableFn, foreach: list.view, as: 'item' }"></tbody>
        <!-- /ko -->
    </table>
</div>
<!-- /ko -->`,
    [Templates.table_recursive_draggable_body]: `<tr data-bind="draggable: { data: item, options: { helper: 'clone' }}">
    <!-- ko if: list.isSelectionOn -->
    <td>
        <div class="checkbox" data-bind="css: list.recursiveSelectionStateCss(item), click: list.toggleSelection"></div>
    </td>
    <!-- /ko -->
    <!-- ko foreach: { data: list.properties, as: 'property' } -->
    <td data-bind="template: property.template, css: property.cellCss, click: property.click.bind(item) "></td>
    <!-- /ko -->
</tr>
<!-- ko foreach: list.dataSource.getFlatChildrenData(item) -->
    <!-- ko foreach: { data: view, as: 'item' } -->
        <!-- ko template: list.getItemTemplate(item) -->
        <!-- /ko-->
    <!-- /ko-->
<!-- /ko-->`,
    [Templates.table_recursive_draggable_bodyWithIsSelectableFn]: `<tr data-bind="draggable: { data: item, isEnabled: list.isSelectable(item), options: { helper: 'clone' }}">
    <!-- ko if: list.isSelectionOn -->
    <td>
        <!-- ko if: list.isSelectable(item) -->
        <div class="checkbox" data-bind="css: list.recursiveSelectionStateCss(item), click: list.toggleSelection"></div>
        <!-- /ko -->
    </td>
    <!-- /ko -->
    <!-- ko foreach: { data: list.properties, as: 'property' } -->
    <td data-bind="template: property.template, css: property.cellCss, click: property.click.bind(item) "></td>
    <!-- /ko -->
</tr>
<!-- ko foreach: list.dataSource.getFlatChildrenData(item) -->
    <!-- ko foreach: { data: view, as: 'item' } -->
        <!-- ko template: list.getItemTemplate(item) -->
        <!-- /ko-->
    <!-- /ko-->
<!-- /ko-->`,
    [Templates.table_recursive_header]: `<tr>
    <!-- ko if: list.isSelectionOn -->
    <th class="checkbox-column">
        <!-- ko if: list.isMultipleSelectionOn -->
        <div class="checkbox" data-bind="css: {'hehe-icons-check' : list.isAllSelected }, click: list.toggleAllSelection"></div>
        <!-- /ko -->
    </th>
    <!-- /ko -->
    <!-- ko foreach: list.properties -->
    <!-- ko template: { name: headerTemplate }-->
    <!-- /ko -->
    <!-- /ko -->
</tr>`,
    [Templates.table_viewHeader]: `<!--<div class="table-header no-gutter mapp-cell-1-1">
    <a class="icon mapp-studio-icons-filter" data-bind="click: clickFilter, visible: isFilterVisible">
        <span>Filter</span>
    </a>
</div>-->

<div class="section-table-header">
    <div data-bind="click: clickFilter, css: {'active': isFilterActive}">
        <a class="icon mapp-studio-icons-filter">
            <span data-bind="text: mapp.Localization.Filter"></span>&nbsp;<span class="selected-count" data-bind="text: filterCountLabel"></span>
        </a>
    </div>
    <div class="widget" data-bind="css: {'active': isSearchActive}, visible: isSearchVisible">
        <input class="list-header-input" type="text" data-bind="attr: {placeholder: mapp.Localization.Search}, textInput: searchInput" />
    </div>
    <!-- ko foreach: customTableActions -->
    <div data-bind="click: onClick, css: {'active': isActive}">
        <a data-bind="css: icon">
            <span data-bind="text: label"></span>
        </a>
    </div>
    <!-- /ko -->
</div>`,
    [Templates.widgets_autocomplete]: `<input data-bind="attr: { id: base.id }, textInput: base.textInput, enable: editable, hasFocus: base.hasFocus, event: { keyup: base.keyUp }" />
<div class="autocomplete-list-wrapper mapp-cell-1-1" data-bind="visible: base.listVisible">
    <div class="autocomplete-list" data-bind="foreach: { data: base.list.view, as: 'item' }, event: { mouseover: base.listHover.bind($data, true), mouseout: base.listHover.bind($data, false) }">
        <div class="autocomplete-item" data-bind="css: { 'selected' : $parent.base.list.isSelected(item) }, click: $parent.base.clickSelect">
            <div data-bind="foreach: { data: $parent.base.list.properties, as: 'property' }">
                <!-- ko template: { name: property.template, data: property } -->
                <!-- /ko -->
            </div>
        </div>
    </div>
</div>`,
    [Templates.widgets_button]: `<a class="ui-action" data-bind="click: click, text: label.label, css: buttonCss, attr: {title: label.label}"></a>`,
    [Templates.widgets_checkbox]: `<div class="checkbox" data-bind="attr: { id: base.id }, css: { 'hehe-icons-check' : value }, click: base.toggle"></div>`,
    [Templates.widgets_combobox]: `<select data-bind="attr: { id: base.id }, value: value, options: base.data, optionsText: base.labelKey, optionsCaption: base.placeholder, disable: !editable(), valueAllowUnset: true, optionsAfterRender: base.optionsAfterRender"></select>`,
    [Templates.widgets_dateTimePicker]: `<input data-bind="attr: { id: base.id }, calendar: base.calendarOptions, enable: editable, hasFocus: base.hasFocus" />`,
    [Templates.widgets_fileInput]: `<div class="file-wrapper">
    <input type="file" class="file-hidden" data-bind="attr: { id: base.id }, enable: editable, element: base.fileElement, event: { change: base.fileChanged }">
    <input type="text" class="file-name" data-bind="value: base.fileName" />
    <div class="file-select action-theme-blue-white" data-bind="click: base.clickFile">
        <a class="action hehe-icons-models">
        </a>
    </div>
</div>`,
    [Templates.widgets_folderPicker]: `<input type="file" webkitdirectory directory multiple data-bind="attr: { id: base.id }, value: value" style="display:none" />
<a data-bind="click: base.click" class="icon hehe-icons-addfolder">
    <span data-bind="text: mapp.Localization.Progress.Select"></span>
</a>`,
    [Templates.widgets_formTable]: `<!-- ko if: base.autoCompleteFilter -->
<input data-bind="textInput: base.textInput, enable: editable" class="widget-wrapper" />
<!-- /ko -->
<!-- ko template: { name: mapp.Templates.table_viewHeader, data: base.table }-->
<!-- /ko -->
<!-- ko template: { name: mapp.Templates.table_base, data: base.table }-->
<!-- /ko -->`,
    [Templates.widgets_iconButton]: `<a class="ui-action" data-bind="click: click, css: buttonCss, attr: {title: label.label}"></a>`,
    [Templates.widgets_imageFileInput]: `<div class="preview-wrapper">
    <img data-bind="attr: { src: base.preview }" />
</div>
<div class="image-file-wrapper" data-bind="template: { name: mapp.Templates.widgets_fileInput, data: $data }">
</div>`,
    [Templates.widgets_input]: `<input data-bind="attr: { id: base.id }, textInput: value, enable: editable, hasFocus: base.hasFocus" />`,
    [Templates.widgets_label]: `<span class="label-widget" data-bind="attr: { id: base.id }, text: value"></span>`,
    [Templates.widgets_labelEdit]: `<div class="ui-action-wrapper-left widget mapp-cell-1-1">
    <span class="label-edit-widget" data-bind="attr: { id: base.id, title: base.title }, text: value"></span>
    <a class="ui-action hehe-icons-editpen" data-bind="click: base.click, visible: base.isEditable"></a>
</div>`,
    [Templates.widgets_listConfirmModalButton]: `<div class="listconfirmmodalbutton-wrapper" data-bind="validationElement: modal.selected, click: click">
    <div class="title"><span data-bind="text: label.label"></span></div>
    <a data-bind="css: buttonCss">
        <span class="label" data-bind="text: hintLabel"></span>
    </a>
</div>`,
    [Templates.widgets_notification]: `<div class="notification-element" data-bind="template: { name: base.notification.template, data: base.notification }"></div>`,
    [Templates.widgets_numberInput]: `<input data-bind="attr: { id: base.id }, textInput: base.numberDisplayValue, enable: editable, hasFocus: base.hasFocus, element: base.element" />`,
    [Templates.widgets_password]: `<input type="password" data-bind="attr: { id: base.id }, textInput: value, enable: editable" />
<!-- ko if: base.passwordOptions -->
<div class="restore-container"><a class="" data-bind="click: base.passwordOptions.click"><span data-bind="text: base.passwordOptions.text"></span></a></div>
<!-- /ko -->`,
    [Templates.widgets_qrcode]: `<img data-bind="attr: { id: base.id, src: base.dataUrl }" width="250" height="250">`,
    [Templates.widgets_radio]: `<div class="radio-wrapper" data-bind="foreach: base.list.view">
    <a data-bind="click: $parent.base.list.toggleSelection, css: { 'selected' : $parent.base.list.isSelected($data) }" class="radio-item">
        <div class="radio-circle"></div>
        <span data-bind="text: label"></span>
    </a>
</div>`,
    [Templates.widgets_simpleCombobox]: `<select data-bind="attr: { id: base.id }, value: value, options: base.data, optionsCaption: base.placeholder, disable: !editable(), valueAllowUnset: true"></select>`,
    [Templates.widgets_textarea]: `<textarea data-bind="attr: { id: base.id }, textInput: value, enable: editable"></textarea>`,
    [Templates.widgets_tinyMce]: `<textarea data-bind="attr: { id: base.id }, enable: editable, tinyMceOptions: base.datasetTinyMceOptions"></textarea>`
});